module.exports = __webpack_public_path__ + "assets/icon-menu-leads.6b51b29e.svg";